import { Route, Routes } from 'react-router';
import { Configurations as ConfigurationsPage } from './configurations';
import React from 'react';
import { TableOfContents } from './table-of-contents/table-of-contents';

export const Configurations = (): JSX.Element => {
  return <Routes>
    <Route path="/" element={<ConfigurationsPage />} />
    <Route path="/:configId/contents/:layerId/*" element={<TableOfContents />} />
  </Routes>;
};
